import { render } from "./AdminPortal.vue?vue&type=template&id=3bb76671"
import script from "./AdminPortal.vue?vue&type=script&lang=js"
export * from "./AdminPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__